const infoContactUs = {
  email: 'hola@xiclo.app',
  phone: '+57 316 3726060',
  pageWeb: 'www.xiclo.app',
  nit: '901495460-7',
}

export default infoContactUs
